import type { FaireProductEntity } from "../../entity_types/product";

export const p_c5thdetsnm: FaireProductEntity = {
  token: "p_c5thdetsnm",
  type: "product",
  name: "LONG SLEEVE ROUND NECK STRIPED SOFT CARDIGAN",
  brandToken: "b_q8gu9by5sv",
  brandName: "LE LIS",
  imageUrl:
    "https://cdn.faire.com/fastly/63750cb327f603a83d28e7cc74e2d6701ef701f811729fdc86e56ee3bbb0848e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9b4a3f6eb693a1d254095f25286a50c5423f6d95e08f19cff284f71b9266b405.jpeg",
    "https://cdn.faire.com/fastly/3129a1c497e8501eb77f9eccccf9f4bfe7d92ec207f67c79cfdb1bdc6dfe2c6d.jpeg",
    "https://cdn.faire.com/fastly/3a993e57ad5a85ec4f26ed34e87454e7e39c9e1986986cfd560b94d3014ce4b2.jpeg",
    "https://cdn.faire.com/fastly/9650f840658a78a7a565748286a0586e29d0c3225bd690d8cd2d8d10c472ca07.jpeg",
    "https://cdn.faire.com/fastly/7dee2dad984fa5b4a514824270e39ee430b1ccf4cf94872750bf247a5e9bd431.jpeg",
    "https://cdn.faire.com/fastly/6fb31a56d4aa90256771aad8f720d9ad4b9a374723d320198b159350a538bfe9.jpeg",
    "https://cdn.faire.com/fastly/3e0ff8f1d24eb4e5276ba6ec4b4ee105e6634c53cfaed1183b10c7d09abb1432.jpeg",
    "https://cdn.faire.com/fastly/b823941ff9856c223a8bb115131f52d46f2f3f6c83f99aa724f028595c46cc43.jpeg",
    "https://cdn.faire.com/fastly/8bafbacab5fac53fe36c5ee430ca03dd63e5b624d8143e24025ca49bcd02edc7.jpeg",
    "https://cdn.faire.com/fastly/154fd713fc913701e12c592e2d2469b84758cca1e2e8902e1f09ab04d8219310.jpeg",
    "https://cdn.faire.com/fastly/b23e7b0bf913b5e4ef31c0e07aaf7a206c47b225c570d260be7cb92e73094084.jpeg",
    "https://cdn.faire.com/fastly/d6b6e0c5be1e4b88a8e9348ed5dbf6f6eb418ece846b82e16878981253a7db9a.jpeg",
    "https://cdn.faire.com/fastly/05e91e481f0c44fece1577319caa5e24e3fe2ba8e725ad9fc46176aa0e294798.jpeg",
    "https://cdn.faire.com/fastly/e7dafda276228fd079f160a29f82213807f163dbde7400be82e71612ae2ee026.jpeg",
    "https://cdn.faire.com/fastly/3b641f8567527305f4b61bd3a84bcb4c0e9e722a4fcfc569a24f3facd3d7db7d.jpeg",
    "https://cdn.faire.com/fastly/41b6b78a05b66886211c19233d2519bd389af4c0c92f8e358df7c82e102bda42.jpeg",
    "https://cdn.faire.com/fastly/4d27c880a139162367d0aece2f8725f8ffe159c1c967c88adf461f14626fa927.jpeg",
    "https://cdn.faire.com/fastly/0700f29f59e00e7a0c3adf8206cdd0ad1cabbe34e598c72a5a73300866af7660.jpeg",
    "https://cdn.faire.com/fastly/7c5d4cd59205ea092c83dcd3b1fac51edd43fbb883c4cdb91e4041a688fd68a5.jpeg",
    "https://cdn.faire.com/fastly/1196fcadfe77d23ca83c1564b8c2b303578e5ce4950ac588c07c8bcf340f217d.jpeg",
    "https://cdn.faire.com/fastly/bb93989ec335db5790deb36165ab797b8ad8475e1a599ff9719286803c3ea602.jpeg",
    "https://cdn.faire.com/fastly/0df673527d0b083454fce3acc051c0696408206cda912aac3410ee9b9d93abfd.jpeg",
    "https://cdn.faire.com/fastly/88c8a677ef191a806c78268ba4f5751a0b63569d71da39320561a4c5015f3aca.jpeg",
    "https://cdn.faire.com/fastly/0babe4d464aeedde45c403f1ed073ffd6451bcb97c3a36ad48429276a8155fb2.jpeg",
    "https://cdn.faire.com/fastly/1c6c87a2981b622a2c63fe74ef781dcd3a441b0e860d57323983f8131fd9ed57.jpeg",
    "https://cdn.faire.com/fastly/d127432c59a37dcef663e97fb1d1a12a0d2a8dc52b4ee1d53ce85b4d4fa087a5.jpeg",
    "https://cdn.faire.com/fastly/9a0e93f28a1c196530e09f24320568992a3194a5e3e0b85dc25007bad6b09505.jpeg",
    "https://cdn.faire.com/fastly/1326fed7313b56f91fe2e0b320008ee3d8ab1ba4ecf9965fc2ac8ff0772887e2.jpeg",
    "https://cdn.faire.com/fastly/cffea337ac5d1b70f37d4da2504c96ab0f76a4deb847e7eacef48e20852387e4.jpeg",
    "https://cdn.faire.com/fastly/72e353efb6c0bd7c966f3730e451dfe244f1f63ddc0f4d979b97f03d2c937c71.jpeg",
    "https://cdn.faire.com/fastly/fda52e792e66e6e9a6ccca617eaf739dd63169da9b034c1626d11652245bb4df.jpeg",
    "https://cdn.faire.com/fastly/40a7adc5996cb8b078a2c69a7b3004d832902fee3df240f4e9281a9c984be771.jpeg",
    "https://cdn.faire.com/fastly/bddfbe1adaf818f0a1e1d66c5e2dcf539ab6a7c76121d0fa41d74048c6643561.jpeg",
    "https://cdn.faire.com/fastly/a0d538c06794ec7eacb83f0ecd9a91c5958e32095ed9d6ce4859b202e807ad1f.jpeg",
    "https://cdn.faire.com/fastly/9138cab08e10b7447063e0fe89e5d503182947807c70df603bb9d00677b7694e.jpeg",
    "https://cdn.faire.com/fastly/f6401ce2c1c6f8d2a79e1f23bfce7f162ac52b3d568a834b0cc4696c1e304dd6.jpeg",
    "https://cdn.faire.com/fastly/8c806055ec190ae3067dc5333743f989eb2d610cbdca47d4f37b7e1b97df89b8.jpeg",
    "https://cdn.faire.com/fastly/dc7f39d4d23584dfb90cb65ceb1187fdf86f041df66af6c9eb5f77aa33eaba4e.jpeg",
    "https://cdn.faire.com/fastly/01342936fe30acbf779aade325d3fc5240d57286c4a06d3f6e0139e395d3f28d.jpeg",
    "https://cdn.faire.com/fastly/56394117240c605638d44b51a5a85776fb248a08c44b3605a5e4a6795f052162.jpeg",
    "https://cdn.faire.com/fastly/a5f4b1d8598a2b127b962a4c4b750bca8a83566ec4470ec360b8da4f7e028005.jpeg",
    "https://cdn.faire.com/fastly/e73b5828864980c7c5edb375db3bb0a458996805adaf31d9d085314d70f77692.jpeg",
    "https://cdn.faire.com/fastly/4daa0ab2e39dd74d03852b56c63de19d49d0b7c70d0b13c7db090e7b46bb7868.jpeg",
    "https://cdn.faire.com/fastly/1faeb3ec8ddd432fe4d6faa5a25117bfb3c25f2d6e7ed461691da8b0667b807f.jpeg",
    "https://cdn.faire.com/fastly/e59c3d85bb2b7faf22af6cd9e5539773955fe16c5217bc603b036f6693be3930.jpeg",
  ],
  priceDollars: 174,
  description:
    'Model is wearing a size small\n\n𝐌𝐨𝐝𝐞𝐥 𝐬𝐩𝐞𝐜𝐬\nHeight: 5\'8"\nBust: 32B\nWaist: 24"\nHips: 34"',
  tags: [],
  msrpDollars: 348,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-11T03:52:10.871Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
